import { AudioWaveRecorderHandle } from 'components/atoms/audio_wave';
import { useRef, useState, useCallback } from 'react';

export const useAudioRecorderController = () => {
  const waveRef = useRef<AudioWaveRecorderHandle>(null);
  const [isRecording, setIsRecording] = useState(false);

  const startRecording = useCallback(() => {
    setIsRecording(true);
  }, []);

  const cancelRecording = useCallback(() => {
    waveRef.current?.cancel();
    setIsRecording(false);
  }, []);

  const stopRecording = useCallback(async (callback: (blob: Blob) => void | Promise<void>) => {
    const blob = await waveRef.current?.stop();
    setIsRecording(false);

    if (blob) {
      await callback(blob);
    }
  }, []);

  return {
    waveRef,
    isRecording,
    startRecording,
    cancelRecording,
    stopRecording,
  };
};
